import Service from '../../Services/Service'

const FreePageAPI = {
    getFreePageData(slug) {
        return Service.get(`/site/free_page?url=${slug}`);
    }
};

export default FreePageAPI;
